import api from '@/services/apiService';

export interface PasswordResetRequestData {
  email?: string;
  note?: string;
}

export interface PasswordResetRequestResponse {
  success: boolean;
  message?: string;
  data?: PasswordResetRequestData;
}

export interface PasswordResetResponse {
  success: boolean;
  message?: string;
}

const requestPasswordReset = async (email: string): Promise<PasswordResetRequestResponse> => {
  const response = await api.post('/auth/request-password-reset', {
    email,
  });
  return response.data;
};

const resetPassword = async (
  token: string,
  new_password: string,
  confirm_password: string
): Promise<PasswordResetResponse> => {
  const response = await api.post('/auth/reset-password', {
    token,
    new_password,
    confirm_password,
  });
  return response.data;
};

export { requestPasswordReset, resetPassword };
